<template>
  <div class="user">
    <div class="photo">
      <img src="static/img/faces/icon-user.png" alt="user avatar"/>
    </div>
    <div class="info">
      <a data-toggle="collapse" :aria-expanded="!isClosed" @click="toggleMenu" href="#">
         <span>
           {{ this.user.username }}
           <b class="caret"></b>
        </span>
      </a>
      <div class="clearfix"></div>
      <div>
        <collapse-transition>
          <ul class="nav nav-menu" v-show="!isClosed">
            <li>
              <a href="#">
                <span class="sidebar-mini-icon">
                  <i class="nc-icon nc-circle-10"></i>
                </span>
                <span class="sidebar-normal">{{ this.user.name }} {{ this.user.lastname }}</span>
              </a>
            </li>
            <li>
              <a href="#">
                <span class="sidebar-mini-icon">
                  <i class="nc-icon nc-email-85"></i>
                </span>
                <span class="sidebar-normal" style="text-transform: none;">{{ this.user.email }}</span>
              </a>
            </li>
            <li>
                <a @click="goToSettings()">
                  <!-- <router-link to="/settings"> -->
                    <span class="sidebar-mini-icon">
                      <i class="nc-icon nc-settings-gear-65"></i>
                    </span>
                    <span class="sidebar-normal">Preferencias</span>
                  <!-- </router-link> -->
                </a>
            </li>
            <li>
                <a @click="goToHelp()">
                    <span class="sidebar-mini-icon">
                      <i class="nc-icon nc-support-17"></i>
                    </span>
                    <span class="sidebar-normal">Ayuda</span>
                </a>
            </li>
           <li>
                <a href="#" @click="userLogout">
                    <span class="sidebar-mini-icon">
                      <i class="nc-icon nc-button-power"></i>
                    </span>
                    <span class="sidebar-normal">Salir</span>
                </a>
            </li>
          </ul>
        </collapse-transition>
      </div>
    </div>
  </div>
</template>
<script>
  import { CollapseTransition } from 'vue2-transitions'
  import userService from '../../../services/user'
  import store from "../../../store";

  export default {
    components: {
      CollapseTransition
    },
    mounted() {
      this.getUserInfo()
    },
    data() {
      return {
        user: {
          username: '',
          name: '',
          lastname: '',
          email: ''
        },
        isClosed: true
      }
    },
    methods: {
      goToSettings() {
        this.$router.push({path: '/settings'})
      },
      goToHelp() {
        this.$router.push({path: 'help'})
      },
      userLogout() {
        //   store.replaceState({})
          userService.logout()
          this.$router.push({path: '/login'})
      },
      toggleMenu() {
        this.isClosed = !this.isClosed
      },
      getUserInfo() {
        userService.userInfo().then(res => {
          this.user.username = res.data.username
          this.user.name = res.data.usr_nombre
          this.user.lastname = res.data.usr_apellido
          this.user.email = res.data.email
        })
      }
    }
  }
</script>
<style scoped>
  .nav.nav-menu {
    margin-top: 0;
  }
</style>
